// Local MobileAppVersion types mirroring the api-v2 MobileAppVersion GraphQL
// schema. NOTE: once the API is deployed and `codegen` re-runs, these can be
// swapped for the generated types in `__generated__/graphql`. Until then the
// generated file does not contain them, so we type the domain/UI layer locally.

export type MobilePlatform = "IOS" | "ANDROID"
export type MobileUpdateType = "NONE" | "OPTIONAL" | "FORCED"

export const MOBILE_RELEASE_NOTE_LOCALES = ["tr", "en", "ar"] as const
export type MobileReleaseNoteLocale =
  (typeof MOBILE_RELEASE_NOTE_LOCALES)[number]

export type MobileReleaseNote = {
  title?: string | null
  body?: string | null
}

export type MobileReleaseNotes = Partial<
  Record<MobileReleaseNoteLocale, MobileReleaseNote | null>
>

export type MobileAppVersionConfig = {
  _id?: string
  platform: MobilePlatform
  latestVersion?: string | null
  minSupportedVersion?: string | null
  updateType?: MobileUpdateType | null
  storeUrl?: string | null
  releaseNotes?: MobileReleaseNotes | null
  updatedBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}

/** The server's verdict for a hypothetical client — used by the preview panel. */
export type MobileAppVersionCheck = {
  platform: MobilePlatform
  currentVersion?: string | null
  latestVersion?: string | null
  minSupportedVersion?: string | null
  updateType: MobileUpdateType
  storeUrl?: string | null
  releaseNotes?: MobileReleaseNotes | null
}

export type UpdateMobileAppVersionConfigInput = {
  platform: MobilePlatform
  latestVersion: string
  minSupportedVersion: string
  updateType: MobileUpdateType
  storeUrl?: string
  releaseNotes?: MobileReleaseNotes
}
